import { Component, View } from 'angular2/core';
import { Router, RouterLink } from 'angular2/router';
import { CORE_DIRECTIVES, FORM_DIRECTIVES } from 'angular2/common';
import { Http, Headers } from 'angular2/http';
import { UserService } from '../user.service';

let template = require('./login.html');

@Component({
  selector: 'login',
})
@View({
  directives: [RouterLink, CORE_DIRECTIVES, FORM_DIRECTIVES],
  template: template,
})
export class Login {
  constructor(public router: Router, public userSvc: UserService) { }

  login($event, username, password) {
    $event.preventDefault();
    this.userSvc.login({ username, password })
      .subscribe(
      response => {
        //TODO(zareone) empty password input in form
        localStorage.setItem('jwt', response.json().token);
        this.router.parent.navigateByUrl('/admin/events/list');
      }, error => {
        alert(error.text());
      });
  }

  signup($event) {
    $event.preventDefault();
    this.router.parent.navigateByUrl('/admin/users/signup');
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/user/login/login.ts
 **/